import React from 'react';
import { IconArrowLeft } from '@/icons';
import { StyledBackButton } from './styles';

function BackButton({ onClick }: { onClick: () => void }) {
  return (
    <StyledBackButton mode="secondary" onClick={onClick} testId="back-button">
      <IconArrowLeft />
    </StyledBackButton>
  );
}

export default BackButton;
